import { GoogleGenerativeAI } from "@google/generative-ai";

const genAI = new GoogleGenerativeAI(process.env.REACT_APP_GEMINI_API_KEY);

export const getMillionInterrogation = async (history, userResponse) => {
  const input = userResponse.toLowerCase().trim();

  // 1. INSTANT FAIL: Childish nonsense
  const nonsense = ["bla bla", "asdf", "lol", "poop", "nothing"];
  if (nonsense.some(word => input.includes(word))) {
      return "FAILED_PROTOCOL"; // This triggers the ejection
  }

  // 2. MERCY RULE: If they try 3 times, let them in.
  const userMessages = history.filter(msg => msg.sender === "user");
  if (userMessages.length >= 3) {
      return "ACCEPTED";
  }

  try {
    const model = genAI.getGenerativeModel({ model: "gemini-2.0-flash" });
    
    const prompt = `
      You are 'Million', the Gatekeeper. 
      User Input: "${userResponse}"
      
      RULES:
      1. If the user is TROLLING, JOKING, or NOT SERIOUS -> Output exactly: "FAILED_PROTOCOL"
      2. If generic ("money") -> REJECT ("Dig deeper.")
      3. If specific/driven -> ACCEPT ("ACCEPTED")
      4. Max 10 words.
    `;

    const result = await model.generateContent(prompt);
    const text = result.response.text().trim();
    return text;
  } catch (error) {
    console.error("Gemini Error:", error);
    return "ACCEPTED"; // Fail open on error
  }
};
